import { ManagementPagePanel } from '../../types';

export const DEFAULT_ACTIVE_PANELS = [ManagementPagePanel.ORDERS_PANEL];

export const OR_MANAGEMENT_UPDATE_PANELS = 'OR_MANAGEMENT_UPDATE_PANELS';

export function updatePanels(activePanels) {
  return {
    type: OR_MANAGEMENT_UPDATE_PANELS,
    activePanels,
  };
}

